import localForage from 'localforage';
import _ from 'lodash';
import Promise from 'bluebird'
import {EMPTY} from "rxjs";
import {auditTime, catchError, concatMap, switchMap} from "rxjs/operators";
import {getAppName} from "util/AppName"
import {getCurrentUserGroupId, getCurrentUserId} from 'module/SessionInfo/api/SessionInfoAPI';
import {upgradeReduxState} from 'util/redux/ReduxStateUpgrader';

const getStateId = () => [
	'Redux',
	getCurrentUserId(),
	getCurrentUserGroupId(),
	getAppName(),
].join('/');

const getGlobalStateId = () => [
	'Global',
	getCurrentUserId(),
	getCurrentUserGroupId(),
].join('/');

const GloballyDisabledNamespaces = [
	'AjaxStatus',
	'DqButton.transient',
	'EntryDesc.favEditMode',
	'EventDialog',
	'Kost.fetched',
	'Modal.SessionInfo.open',
	'Modal.AppVersionInfo.open',
	'MultiEdit',
	'Noti.open',
	'SessionInfo.data',
	'TopNavBar',
];

const GlobalStorage = [
	'Menu',
	'Modal.SessionInfo',
	'Modal.NotiDrawer',
	'Noti',
	'Theme.global',
	'UserConfig.SessionInfo',
];

let blockSaveToLocalStorage = false;

export const requestRemoveAppStateFromLocalStorage = () => {
	blockSaveToLocalStorage = true;
	// do not use react confirm dialog, because it may be crashed
	if (confirm(
		'Sind sie sich sicher, dass sie ihre lokalen, persönlichen Einstellungen dieser Applikation zurücksetzen wollen?',
	)) {
		removeAppStateFromLocalStorage().then(() => setTimeout(() => window.location.reload(), 800));
	} else {
		blockSaveToLocalStorage = false;
	}
};

export const removeAppStateFromLocalStorage = () => Promise.all([
	localForage.removeItem(getStateId()),
	localForage.removeItem(getGlobalStateId()),
]);

export const loadUpgradedStateFromLocalStorage = () =>
	Promise.all([localForage.getItem(getGlobalStateId()), localForage.getItem(getStateId())])
		.then(([globalState, appState]) => upgradeReduxState(_.merge({}, globalState, appState)))
		.catch(err => {
			log.error("Error loading store: ", err);
			return undefined;
		})

let lastSavedState = null;
const persistState = (state) => {
	if (blockSaveToLocalStorage) return;
	state = _.omit(state, GloballyDisabledNamespaces);
	if (_.isEqual(state, lastSavedState)) return;
	return localForage.setItem(
		getStateId(),
		_.omit(state, GlobalStorage),
	).then(() =>
		localForage.setItem(
			getGlobalStateId(),
			_.pick(state, GlobalStorage),
		));
};

export const persistStateToClientStorageEpic = (action$, state$) => state$.pipe(
	auditTime(1500),
	concatMap(state => persistState(state)),
	catchError(err => {
		log.error(err);
		return EMPTY;
	}),
	switchMap(() => EMPTY),
);
